export default "__VITE_ASSET__BTTD05AX__"